import React from 'react';
import PropTypes from 'prop-types';
import { Link, NavLink } from 'react-router-dom';
import classnames from 'classnames';
import PhishingIcon, { phishingMenuIcon } from '../Components/PhishingIcon';

class RouterLink extends React.Component {

  constructor(props) {
    super(props);

    this.onLocationChange = this.onLocationChange.bind(this);
  }

  componentDidMount() {
    this.to = this.props.to;
    if (this.to[0] !== '/') this.to = `/${this.to}`;
  }

  // componentWillMount() {
  //   this.to = this.props.to;
  //   if (this.to[0] !== '/') this.to = `/${this.to}`;

  //   this.context.router.history.listen(this.onLocationChange.bind(this));
  //   this.onLocationChange(this.context.router.route);
  // }

  onLocationChange(e) {
    if ((e.pathname || '/') === this.to) {
      this.props.activateMe();
    }
  }

  render() {
    const {
      className,
      classNameActive,
      classNameHasActiveChild,
      active,
      hasActiveChild,
      to,
      externalLink,
      hasSubMenu,
      toggleSubMenu,
      children,
    } = this.props;
    const icon = phishingMenuIcon(to);
    // Section routes include campaign creation and results, whose URLs differ
    // from the menu destination. Let the router keep their selection in sync.
    const InternalLink = icon ? NavLink : Link;
    const routeProps = icon ? {
      activeClassName: classNameActive,
      isActive: (_match, location) => phishingMenuIcon(location.pathname) === icon,
    } : {};
    const content = icon ? React.Children.map(children, child => React.isValidElement(child) && child.type === 'i' &&
      (child.props.className || '').split(/\s+/).includes('metismenu-icon')
      ? React.cloneElement(child, { className: 'metismenu-icon phishing-menu-icon', 'aria-hidden': true }, <PhishingIcon name={icon} />)
      : child) : children;

    return (
      hasSubMenu || externalLink
      ? (
        <a
          className={classnames(
            className,
            hasActiveChild && classNameHasActiveChild
          )}
          target={externalLink ? '_blank' : undefined}
          href={to}
          onClick={toggleSubMenu}
        >
          {content}
        </a>
      )
      : (
        <InternalLink
          className={classnames(
            className,
            icon && 'phishing-menu-link',
            !icon && active && classNameActive
          )}
          to={to}
          {...routeProps}
        >
          {content}
        </InternalLink>
      )
    );
  }
}

RouterLink.propTypes = {
  className: PropTypes.string.isRequired,
  classNameActive: PropTypes.string.isRequired,
  classNameHasActiveChild: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  hasActiveChild: PropTypes.bool.isRequired,
  to: PropTypes.string.isRequired,
  externalLink: PropTypes.bool,
  hasSubMenu: PropTypes.bool.isRequired,
  toggleSubMenu: PropTypes.func,
  activateMe: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
  ]).isRequired,
};

// RouterLink.contextTypes = {
//   router: PropTypes.object.isRequired,
// };

export default RouterLink;
